// extracted by mini-css-extract-plugin
export var SectionWrapper = "Slider-module--SectionWrapper--1kT86";
export var SectionNavigation = "Slider-module--SectionNavigation--1z-V1";
export var CustomParagraph = "Slider-module--CustomParagraph--2ZTdk";
export var NavigationContentWrapper = "Slider-module--NavigationContentWrapper--QYI7s";
export var ButtonContent = "Slider-module--ButtonContent--1yJvJ";
export var ButtonContentActive = "Slider-module--ButtonContentActive--3KfsJ";
export var ProgressBar = "Slider-module--ProgressBar--1WgF4";
export var SliderWrapper = "Slider-module--SliderWrapper--1p5ZO";
export var SliderItem = "Slider-module--SliderItem--2UuSr";